import { ClientSociety, ClientUser } from "@dune/types/src";
import { SelectedClient } from "../pages/constructionSites/projectForm/CommonProjectForm";

export const isClientUser = (
	client: ClientUser | ClientSociety,
): client is ClientUser => {
	return "email" in client;
};

export const isClientUsers = (
	client: SelectedClient,
): client is ClientUser[] => {
	return (
		Array.isArray(client) && client.every((client) => isClientUser(client))
	);
};
